// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .p-fileupload-buttonbar {
  display: none;
}

:host ::ng-deep .p-fileupload-files {
  display: none;
}

:host ::ng-deep .p-progressbar {
  display: none;
}

:host ::ng-deep .p-message {
  display: none;
}

:host ::ng-deep .p-fileupload .p-fileupload-content {
  padding: 0;
  border: 0;
  width: 20rem;
  border-radius: 1rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
}

.drop-container {
  cursor: pointer;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity));
  padding-top: 2rem;
  padding-bottom: 2rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.small-primary-text {
  cursor: pointer;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(18 38 51 / var(--tw-text-opacity));
}

.rule-container {
  height: 3rem;
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.small-gray-text {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  --tw-text-opacity: 1;
  color: rgb(122 122 122 / var(--tw-text-opacity));
}

.filename-container {
  height: 3rem;
  align-items: center;
  justify-content: space-between;
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.thumbnail {
  height: 9rem;
  width: 100%;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  object-fit: cover;
}

.trash-icon {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  cursor: pointer;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding: 0.5rem;
  font-weight: 600;
}

.search-icon {
  position: absolute;
  right: 0.75rem;
  top: 8rem;
  display: flex;
  height: 2rem;
  width: 2rem;
  cursor: pointer;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(202 215 223 / var(--tw-bg-opacity));
  font-weight: 600;
}

.search-icon:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(95 134 157 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

::ng-deep .show-picture-dialog {
  border: 0;
}
::ng-deep .show-picture-dialog .p-dialog-header {
  display: none;
}
::ng-deep .show-picture-dialog .p-dialog-content {
  background-color: transparent;
  border-color: transparent;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/image-uploader/image-uploader.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,UAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,kFAAA;AACF;;AAGE;EAAA,eAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,kBAAA;EAAA,yDAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA;AAAA;;AAIA;EAAA,eAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA;AAAA;;AAIA;EAAA,YAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,kBAAA;EAAA,yDAAA;EAAA,mBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA;AAAA;;AAIA;EAAA,mBAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA;AAAA;;AAIA;EAAA,YAAA;EAAA,mBAAA;EAAA,8BAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,kBAAA;EAAA,yDAAA;EAAA,oBAAA;EAAA;AAAA;;AAIA;EAAA,YAAA;EAAA,WAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA;AAAA;;AAIA;EAAA,kBAAA;EAAA,aAAA;EAAA,WAAA;EAAA,eAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,yDAAA;EAAA,eAAA;EAAA;AAAA;;AAIA;EAAA,kBAAA;EAAA,cAAA;EAAA,SAAA;EAAA,aAAA;EAAA,YAAA;EAAA,WAAA;EAAA,eAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,yDAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA;AAAA;;AAGF;EAWE,SAAA;AATF;AADE;EACE,aAAA;AAGJ;AAAE;EACE,6BAAA;EACA,yBAAA;EACA,UAAA;AAEJ","sourcesContent":[":host ::ng-deep .p-fileupload-buttonbar {\n  display: none;\n}\n\n:host ::ng-deep .p-fileupload-files {\n  display: none;\n}\n\n:host ::ng-deep .p-progressbar {\n  display: none;\n}\n\n:host ::ng-deep .p-message {\n  display: none;\n}\n\n:host ::ng-deep .p-fileupload .p-fileupload-content {\n  padding: 0;\n  border: 0;\n  width: 20rem;\n  border-radius: 1rem;\n  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n}\n\n.drop-container {\n  @apply tw-bg-gray-very-light tw-py-8 tw-px-10 tw-rounded-t-2xl tw-cursor-pointer;\n}\n\n.small-primary-text {\n  @apply tw-text-sm tw-text-primary tw-font-semibold tw-cursor-pointer;\n}\n\n.rule-container {\n  @apply tw-h-12 tw-bg-white tw-py-2 tw-px-10 tw-rounded-b-2xl;\n}\n\n.small-gray-text {\n  @apply tw-text-sm tw-text-gray-mid tw-font-light;\n}\n\n.filename-container {\n  @apply tw-items-center tw-h-12 tw-bg-white tw-px-2 tw-rounded-b-2xl tw-justify-between;\n}\n\n.thumbnail {\n  @apply tw-object-cover tw-h-36 tw-w-full tw-rounded-t-2xl;\n}\n\n.trash-icon {\n  @apply tw-absolute tw-bg-white tw-font-semibold tw-p-2 tw-right-2 tw-top-2 tw-rounded-lg tw-cursor-pointer;\n}\n\n.search-icon {\n  @apply tw-flex tw-absolute tw-bg-blue-25 tw-font-semibold tw-w-8 tw-h-8 tw-right-3 tw-top-32 tw-rounded-full tw-cursor-pointer hover:tw-bg-blue-75 hover:tw-text-white;\n}\n\n::ng-deep .show-picture-dialog {\n  .p-dialog-header {\n    display: none;\n  }\n\n  .p-dialog-content {\n    background-color: transparent;\n    border-color: transparent;\n    padding: 0;\n  }\n\n  border: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
